import * as React from 'react';

// tslint:disable:max-line-length
export const WashingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H2V2h12v12z" />
      <path d="M8 13c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-2c-1.5 0-2.7-1.1-2.9-2.5 1.3-.7 1.6-.4 2.2.2.9.9 1.8 1.4 3.1 1.1-.6.8-1.5 1.2-2.4 1.2zm0-6c1.5 0 2.7 1.1 2.9 2.5-1.3.8-1.6.4-2.2-.2-.8-.7-1.7-1.4-3.1-1.1C6.2 5.5 7 5 8 5z" />
    </g>
  </svg>
);
